<template>
  <div class="service-utilize-container">
    <div class="columns is-multiline">
      <!--<div class="column is-full">
        <lp-adm-drop-input :data="option.service"
                           @onSelect="res => selectedService = res.value"
                           placeholder="검색 후 선택"
                           width="250px"
                           listAlign="left"></lp-adm-drop-input>
      </div>-->
      <div class="column is-full">
        <div class="box" v-if="service">
          <admin-box-item title="서비스 정보" :useTab="false">
            <div class="columns">
              <div class="column is-6">
                <div class="grid-row">
                  <div class="grid-title">서비스명</div>
                  <div class="grid-content flex-align" style="gap:0 12px">
                    <div>{{ service.service_name }}</div>
                    <a :href="`${service.domain}`" target="_blank">
                      <button class="button">서비스 바로가기</button>
                    </a>
                    <a :href="`${service.domain}/office/admin`" target="_blank">
                      <button class="button">관리자 바로가기</button>
                    </a>
                  </div>
                </div>
                <div class="grid-row">
                  <div class="grid-title">고객명</div>
                  <div class="grid-content flex-align" v-if="service.user">
                    <a :href="`/office/admin/user/create?id=${service.user.id}`" target="_blank">{{ service.user.name }}</a>
                  </div>
                </div>
                <div class="grid-row">
                  <div class="grid-title">이용일</div>
                  <div class="grid-content flex-align" v-if="service.schedule">
                    <div>{{ datesFormat(service.schedule.start_date, 'date_3') }} ~
                      <span v-if="service.schedule.end_date && service.schedule.end_date !== ''">({{ datesFormat(service.schedule.end_date, 'date_3') }})</span></div>
                      <button class="button" style="margin-left:12px" @click="routerDetail">이용일 설정</button>
                  </div>
                </div>
                <div class="grid-row">
                  <div class="grid-title">다음 결제 예정일</div>
                  <div class="grid-content flex-align" v-if="service.schedule">
                    <div>{{ datesFormat(service.schedule.next_date, 'date_3') }}</div>
                  </div>
                </div>
              </div>
              <div class="column is-6">
                <div class="grid-row-end">
                  <div class="grid-title">총 이용 금액</div>
                  <div class="grid-content">{{ service.total_price.utilize|currency }}</div>
                </div>
                <div class="grid-row-end">
                  <div class="grid-title">총 결제 금액</div>
                  <div class="grid-content">{{ service.total_price.account|currency }}</div>
                </div>
                <div class="grid-row-end">
                  <div class="grid-title">총 충전금</div>
                  <div class="grid-content">{{ service.total_price.charge|currency }}</div>
                </div>
                <div class="grid-row-end">
                  <div class="grid-title">충전금 사용 잔액</div>
                  <div class="grid-content">{{ service.total_price.charge_remain|currency }}</div>
                </div>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
      <div class="column is-full" v-if="service">
        <div class="flex-end">
          <button class="button is-primary" @click="clickReg">수기 등록</button>
        </div>
      </div>
      <div class="column is-full">
        <admin-filter
          :items="filterData"
          :itemFiltered.sync="filtered"
          @getData="getDataFromServer"
          title="이용결제내역 조회"
          ref="admin_filter"></admin-filter>
      </div>
      <div class="column is-full">
        <admin-table :field_list="tableData"
                     :items="tableItems"
                     :filtered="filtered"
                     :allCount="allCount"
                     :filteredCount="filteredCount"
                     :table_width="1808"
                     @getData="getDataFromServer"
                     @ordering="ordering"
                     @selPageLength="selPageLength">
          <div slot="billing_date" slot-scope="props">{{ datesFormat(props.item.billing_date, 'date_3') }}</div>
          <div slot="product_price" slot-scope="props">{{ currency(props.item.product_price) }}</div>
          <div slot="account_price" slot-scope="props">{{ currency(props.item.account_price) }}</div>
          <div slot="pay_method" slot-scope="props">{{ pay_method_kor(props.item.pay_method) }}</div>
          <div slot="status" slot-scope="props">{{ status_kor(props.item.status) }}</div>
          <div slot="billing_status" slot-scope="props">{{ billing_status_kor(props.item.billing_status) }}</div>
          <div slot="account_date" slot-scope="props">{{ datesFormat(props.item.account_date, 'date_3') }}</div>
          <div slot="taxbill_date" slot-scope="props">{{ datesFormat(props.item.taxbill_date, 'date_3') }}</div>
          <div slot="invoice_date" slot-scope="props">{{ datesFormat(props.item.invoice_date, 'date_3') }}</div>
          <div slot="update" slot-scope="props">
            <button class="button" @click="clickItem(props.item)" style="width:68px">수정하기</button>
          </div>
        </admin-table>
      </div>
    </div>
    <modal-utilize ref="utilModal" v-if="service" :updateItem="selectedItem"
                   :service_id="service.id" @close="onCloseModal"></modal-utilize>
  </div>
</template>

<script>
  import Pagination from "../../../module/common/Pagination";
  import ModalUtilize from "./components/ModalUtilize";
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";
  import ListMixin from "../../../../mixins/ListMixin";

  export default {
    name: 'ServiceUtilize',
    mixins: [
      ListMixin
    ],
    components: {
      LpAdmDropInput,
      ModalUtilize,
      Pagination
    },
    created() {
      this.init();
    },
    watch: {
      /*selectedService(n) {
        if(n) {
          this.getService();
        }
      },*/
    },
    data() {
      return {
        selectedService: undefined,
        option: {
          service: [],
          pay_method: [
            {value: 0, label: '빌링결제(이니시스)', checked: false},
            {value: 1, label: '계좌이체', checked: false},
            {value: 2, label: '빌링결제(페이플)', checked: false},
            {value: 3, label: '충전금 소진', checked: false}
          ],
          category: [],
          status: [
            {value: '', label: '전체'},
            {value: 0, label: '결제대기'},
            {value: 1, label: '결제완료'},
            {value: 2, label: '입금완료'}
          ],
          billing_status: [
            {value: 0, label: '청구대기'},
            {value: 1, label: '청구완료'}
          ]
        },
        service: undefined,
        selectedItem: undefined
      }
    },
    methods: {
      pay_method_kor(item) {
        return this.option.pay_method.filter(i => i.value === item)[0].label;
      },
      status_kor(item) {
        return this.option.status.filter(i => i.value === item)[0].label;
      },
      billing_status_kor(item) {
        return this.option.billing_status.filter(i => i.value === item)[0].label;
      },
      getDataFromServer() {
        this.getService();
      },
      routerDetail() {
        this.$router.push(this.getPath(`launchpack/service/detail?id=${this.service.id}`));
      },
      clickItem(item) {
        this.selectedItem = item;
        this.$refs.utilModal.open();
      },
      onCloseModal() {
        this.getData();
      },
      clickReg() {
        this.selectedItem = undefined;
        this.$refs.utilModal.open();
      },
      async init() {
        // 카테고리
        let res = await this.$axios.get('public/category?depth=3');
        let categories = [{
          id: '',
          name: '전체'
        }];
        // 디자인마켓
        categories.push(res.data.filter(i => i.id === 39)[0].child.filter(i => i.name === '테마')[0]);
        // 앱마켓
        categories = categories.concat(res.data.filter(i => i.id === 46)[0].child);
        // 서비스 관리
        categories.push(res.data.filter(i => i.id === 50)[0].child.filter(i => i.name === '호스팅')[0]);

        this.option.category = categories.map(i => {
          return {
            label: i.name,
            value: i.id
          }
        });


        this.initializing('launchpack_service_utilize', 'launchpack/service/0/utilize');
        // 기간 시작을 올해 1월 1일로.
        this.filtered.start = `${this.moment().format('YYYY-')}01-01`;
        this.filterData.find(i => i.type === 'period').start = this.filtered.start;
        this.filtered.ordering = '-billing_date';
        this.$nextTick(()=>{
          let items = this.$refs.admin_filter.items;
          items.filter(i => i.key === 'category')[0].options = this.option.category;
          items.filter(i => i.key === 'pay_method')[0].options = this.option.pay_method;
          items.filter(i => i.key === 'status')[0].options = this.option.status;
        });


        // 서비스
        res = await this.$axios.get(this.getUrl('launchpack/service/simple'));
        this.option.service = res.data;
        //this.selectedService = this.option.service[0].value;
        this.selectedService = this.$route.query.id;
          this.getService();
      },
      async getService() {
        let params = {};
        if(this.filtered.start && this.filtered.start !== '') {
          params['billing_date__start'] = this.filtered.start;
        }
        if(this.filtered.end && this.filtered.end !== '') {
          params['billing_date__end'] = this.filtered.end;
        }

        this.post_url = `launchpack/service/${this.selectedService}/utilize`;
        let res_info = await this.$axios.get(this.getUrl(this.post_url+'_info'), {params: params});
        this.service = res_info.data;
        this.getData();
      }
    }
  }
</script>

<style lang="stylus" scoped>
  $background2=#f5f5f5
  $border-main=#dddddd
  $border-sub=#eeeeee
  $primary=#ff5722

  .grid-row
  .grid-row-end
    display grid
    grid-column-gap 8px
    font-size 14px
    margin-bottom 8px
    align-items center

  .grid-row
    grid-template-columns 120px 1fr

  .grid-row-end
    grid-template-columns 1fr 90px
    text-align right

  .grid-title
    font-weight 600

  .button
    width 110px

  .check-box
    input
      margin-right 4px
      vertical-align middle
      border 1px solid #dddddd

  .service-utilize-container
    table
      width 100%
      border 1px solid $border-main
      th
      td
        vertical-align middle
        text-align center
        border 1px solid $border-main
        padding 4px 8px
      th
        background-color $background2
      tr:hover
        background-color #ff572210
        cursor pointer
</style>
<style lang="stylus">
  .lp-date-picker
    margin-bottom 0 !important
  .mx-datepicker
    width 130px
  .title-group
    margin-bottom 12px !important
</style>
